import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function ServicesHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 80);
    return () => clearTimeout(t);
  }, []);

  const scrollToServices = () => {
    const target = document.getElementById('services-grid');
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    const target = document.getElementById('contact-services');
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/64d4f3eb60912cb9d4403cce3e8ef23d.jpg"
          alt="CJ Solutions Services"
          width={1920}
          height={1080}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950/85 via-slate-900/70 to-slate-900/40"></div>
      </div>

      <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-transparent via-amber-500 to-transparent opacity-60"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-36">
        <div className="max-w-3xl">
          {/* Badge */}
          <div
            className={`mb-6 flex items-center gap-3 transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <div className="w-8 h-0.5 bg-amber-500"></div>
            <span className="text-amber-400 text-sm font-semibold uppercase tracking-widest">
              Expert Corporate &amp; Compliance Services
            </span>
          </div>

          {/* Title */}
          <h1
            className={`text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-[1.05] mb-6 transition-all duration-700 delay-150 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            Compliance.<br />
            <span className="text-amber-400">Growth.</span><br />
            Confidence.
          </h1>

          {/* Description */}
          <p
            className={`text-lg lg:text-xl text-white/80 leading-relaxed mb-10 max-w-2xl transition-all duration-700 delay-300 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            From iGaming licensing and AML outsourcing to company formation and tax advisory&nbsp; CJ Solutions delivers end-to-end regulatory and corporate expertise so your business can scale without limits.
          </p>

          {/* CTA Buttons */}
          <div
            className={`flex flex-wrap gap-4 transition-all duration-700 delay-[450ms] ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <button
              onClick={scrollToContact}
              className="inline-flex items-center gap-2 px-8 py-4 bg-amber-500 hover:bg-amber-600 text-white text-base font-semibold rounded-lg transition-all duration-300 shadow-lg shadow-amber-500/30 cursor-pointer whitespace-nowrap"
            >
              <span>Book a Free Consultation</span>
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={scrollToServices}
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/40 hover:border-white text-white text-base font-semibold rounded-lg transition-all duration-300 backdrop-blur-sm cursor-pointer whitespace-nowrap"
            >
              <span>Explore Services</span>
              <i className="ri-arrow-down-line"></i>
            </button>
          </div>

          {/* Trust indicators */}
          <div
            className={`mt-14 flex flex-wrap items-center gap-8 transition-all duration-700 delay-[600ms] ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            {[
              { icon: 'ri-shield-check-line', label: 'CySEC & FIAU Compliant' },
              { icon: 'ri-global-line', label: 'EU-Regulated Jurisdiction' },
              { icon: 'ri-award-line', label: '15+ Years Experience' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-white/70">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-amber-400 text-lg`}></i>
                </div>
                <span className="text-sm font-medium">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="absolute bottom-0 right-8 hidden sm:block">
        <div className="bg-black/30 backdrop-blur-sm border border-white/20 rounded-t-xl px-6 py-3">
          <nav className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide">
            <Link to="/" className="text-white/70 hover:text-amber-400 transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line text-white/40"></i>
            <span className="text-white">Services</span>
          </nav>
        </div>
      </div>
    </section>
  );
}
